module.exports = __webpack_public_path__ + "files/9a6e5307405faf1cb35b88c3353599c5.png";